module.exports = __webpack_public_path__ + "img/ico-download-doc.7b2eb7e0.svg";